export default {
  AUTH_TOKEN: 'AUTH_TOKEN_ADVEASY_ADMIN',
  PHOTO_URL: 'https://s3.sa-east-1.amazonaws.com/static.adveasy.com.br/',
};
